import { DateHelper } from '../misc/dateHelpers';
import { BaseItem, createBaseItem } from './baseItem';
import { Expenses } from './expenses';
import { Receipt } from './receipt';
import { TripData } from './tripData';
import { WorkflowState } from './workflow';
import { z } from 'zod';

export const BucketPayments = z.object({
    total: z.number(),
    payableTotal: z.number(),
    paidTotal: z.number(),
    /** payableTotal and paidTotal differ - false before the payment stage (nothing payable yet) */
    needsPayment: z.boolean(),
});

export const BucketBase = BaseItem.extend({
    ownerId: z.string(),
    state: WorkflowState,
    archived: z.boolean().nullish(),
    payments: BucketPayments.nullish(),
});
export type BucketBase = z.infer<typeof BucketBase>;

export const Trip = BucketBase.extend({
    type: z.literal('trip'),
    tripData: TripData,
    expenses: z.array(Expenses),
    receipts: z.array(Receipt),
});
export type Trip = z.infer<typeof Trip>;

export const Standalone = BucketBase.extend({
    type: z.literal('standalone'),
    receipts: z.tuple([Receipt]),
});
export type Standalone = z.infer<typeof Standalone>;

export const Bucket = z.discriminatedUnion('type', [Trip, Standalone]);
export type Bucket = z.infer<typeof Bucket>;

export function createTrip(
    id: string,
    tripData: TripData,
    ownerId: string,
    agent?: string | null,
): Trip {
    return {
        ...createBaseItem(id),
        type: 'trip',
        ownerId,
        state: 'draft',
        tripData: tripData,
        expenses: [],
        receipts: [],
        history: [
            {
                action: 'create',
                author: ownerId,
                agent: agent ?? undefined,
                date: DateHelper.now(),
                values: { ownerId, trip: tripData },
            },
        ],
    };
}

export function createStandalone(
    id: string,
    receipt: Receipt,
    ownerId: string,
    agent?: string | null,
): Standalone {
    return {
        ...createBaseItem(id),
        type: 'standalone',
        ownerId,
        state: 'draft',
        receipts: [receipt],
        history: [
            {
                action: 'create',
                author: ownerId,
                agent: agent ?? undefined,
                date: DateHelper.now(),
                values: { ownerId },
            },
        ],
    };
}
